import { Divider, Heading, Icon, Stack, Text } from "@chakra-ui/react";
import { AiFillWarning } from "react-icons/ai";
import { FaHome, FaInfo, FaRedo, FaUserCog, FaUserPlus } from "react-icons/fa";
import { MdEmail, MdNotifications } from "react-icons/md";
import { RiFolderWarningFill } from "react-icons/ri";
import DashboardButtons from "../../../components/Buttons/DashboardButtons";

export default function ManagementPortal() {
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack align={'flex-start'} spacing={4}>
                    <Stack direction={'row'}>
                        <Icon as={FaHome} fontSize={'5xl'} color={'primary.400'} />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Management Portal</Heading>
                            <Text fontSize={'sm'}>Operations, errors, system settings, and user accounts</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <Stack p={4} w={'98%'} spacing={4} rounded={'xl'} boxShadow={'base'} divider={<Divider />}>
                <Stack spacing={2}>
                    <Heading fontSize={'2xl'}>Errors and Exceptions</Heading>
                    <Stack w={'full'} spacing={4} direction={'row'} justify={'space-between'}>
                        <DashboardButtons Icon={AiFillWarning} bg={'gray.600'} text={'Exception Management'} _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.800' }} to={'/internal/exception-management'} />
                        <DashboardButtons Icon={RiFolderWarningFill} bg={'gray.600'} text={'Export Errors'} _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.800' }} to={'/internal/export-errors'} />
                        <DashboardButtons Icon={FaInfo} bg={'gray.600'} text={'Temp Disconnected Entities'} _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.800' }} to={'/internal/temp-disconnected-entities'} />
                        <DashboardButtons Icon={FaRedo} bg={'gray.600'} text={'Chargebee Sync'} _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.800' }} to={'/internal/chargebee-sync'} />
                    </Stack>
                    <Stack w={'full'} spacing={4} direction={'row'} justify={'space-between'}>
                        <DashboardButtons Icon={MdEmail} bg={'gray.600'} text={'Email Inbox'} _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.800' }} to={'/internal/email-inbox'} />
                        <DashboardButtons Icon={AiFillWarning} bg={'gray.600'} text={'Upload Errors'} _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.800' }} to={'/internal/upload-errors'} />
                    </Stack>
                </Stack>
                <Stack spacing={2}>
                    <Heading fontSize={'2xl'}>System Setup</Heading>
                    <Stack w={'full'} spacing={4} direction={'row'} justify={'space-between'}>
                        <DashboardButtons Icon={MdNotifications} bg={'green.600'} text={'Notification Settings'} _hover={{ bg: 'green.700' }} _active={{ bg: 'green.800' }} to={'/internal/notification-settings'} />
                        <DashboardButtons Icon={FaUserCog} bg={'green.600'} text={'User Roles'} _hover={{ bg: 'green.700' }} _active={{ bg: 'green.800' }} to={'/internal/user-roles'} />
                        <DashboardButtons Icon={FaUserPlus} bg={'green.600'} text={'Create User'} _hover={{ bg: 'green.700' }} _active={{ bg: 'green.800' }} to={'/management/users/create'} />
                        <DashboardButtons Icon={FaUserCog} bg={'green.600'} text={'All Users'} _hover={{ bg: 'green.700' }} _active={{ bg: 'green.800' }} to={'/management/users'} />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
}
